import {TaskType} from '../enums/TaskType';
import {getAssetTasks} from '../reducers/state';
import {makeTaskList} from './configTasks';
import {ASSET_LIST_PREFIX} from './state';


export const {
  defaultFilterOptions,
  filterModalOptions,
  reduxList,
  componentOptions,
  isVisible,
} = makeTaskList({
  taskType: TaskType.ASSET,
  prefix: ASSET_LIST_PREFIX,
  getState: getAssetTasks,
  parentPath: 'asset-projects',
  resourcePath: `asset-tasks`,
  childPath: 'asset-tasks',
});



// WEBPACK FOOTER //
// ./src/js/tasks/redux/assetTasks.js